import React from 'react'
import { useSelector } from 'react-redux'

import { Button,Div } from '@driftt/tide-core'
import { ModalBody, ModalFooter, ModalTitle, useCloseModal } from '@driftt/tide-modal'
import { access } from '@driftt/traffic-control'

import { getHasAbility } from '../../selectors'

import AccountNotificationSection from './sections/AccountNotificationSection'
import AdministratorSection from './sections/AdministratorSection'
import ConversationNotificationSection from './sections/ConversationNotificationSection'
import SoundAndAppearanceSection from './sections/SoundAndAppearanceSection'
import TopSection from './sections/TopSection'
import TroubleshootNotificationsSection from './sections/TroubleshootNotificationsSection'

import styles from './styles.module.css'

interface DefaultSettingsProps {
  formikValues: Record<string, any>
  onSelectAccountFilter: (filter: any) => void
  numUnsavedChanges: number
  isSubmitting: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  hidden: boolean
}

const NotificationsDefaultSettings: React.FC<DefaultSettingsProps> = ({
  formikValues,
  onSelectAccountFilter,
  numUnsavedChanges,
  isSubmitting,
  setFieldValue,
  hidden
}) => {
  const closeModal = useCloseModal()
  const hasConvoNotifications = Boolean(useSelector(getHasAbility('hasConvoNotifications')))
  const hasAccountActivityNotifications = Boolean(
    useSelector(getHasAbility('hasAccountActivityNotifications'))
  )
  const hasAdminNotificationSettings = Boolean(
    useSelector(getHasAbility('hasAdminNotificationSettings'))
  )

  const hasSavedViewEmailDigest = access.hasGates('account_activity_email_digest')
  const hasSavedViewNotifications = access.hasGates('saved_filters_push_notifications')

  return (
    <div hidden={hidden}>
      <ModalTitle>Notifications</ModalTitle>
      <ModalBody>
        <TopSection formikValues={formikValues} />
        {hasConvoNotifications && <ConversationNotificationSection />}
        {hasAccountActivityNotifications && (
          <AccountNotificationSection
            hasSavedViewEmailDigest={hasSavedViewEmailDigest}
            hasSavedViewNotifications={hasSavedViewNotifications}
            onSelectSavedFilter={onSelectAccountFilter}
            setFieldValue={setFieldValue}
          />
        )}
        {hasAdminNotificationSettings && <AdministratorSection setFieldValue={setFieldValue} />}
        <SoundAndAppearanceSection />
        <TroubleshootNotificationsSection
          soundSetting={formikValues.properties['humane-notifications-browser-sound']}
        />
      </ModalBody>
      <ModalFooter className={styles.modalFooter}>
        <Button className={styles.saveButton} submit loading={isSubmitting}>
          Save
        </Button>
        <Button type="tertiary" onClick={closeModal}>
          Cancel
        </Button>
        {numUnsavedChanges > 0 && (
          <Div className={styles.unsavedChangesText}>
            {numUnsavedChanges} unsaved change{numUnsavedChanges > 1 && 's'}
          </Div>
        )}
      </ModalFooter>
    </div>
  )
}

export default NotificationsDefaultSettings
